/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { updateProfilePostRequestSchema } from './updateProfilePostRequestSchema.ts';
import { updateProfilePostResponseSchema } from './updateProfilePostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postUpdateProfile200Schema = z.lazy(() => updateProfilePostResponseSchema);

/**
 * @description 505 response
 */
export const postUpdateProfile505Schema = z.any();

export const postUpdateProfileMutationRequestSchema = z.lazy(() => updateProfilePostRequestSchema);

export const postUpdateProfileMutationResponseSchema = z.lazy(() => postUpdateProfile200Schema);
